import { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import { LogoContainer } from '../../layouts/BasicLayout/styled';
import breakpoints from '../../utilities/breakpoints';
import NotificationGlobalStyle from '../default/notification/NotificationGlobalStyle';
import { FooterGlobalStyle } from '../GlobalStyles';
import themeTokens from './themeTokens';

export const VW_THEME_CLASSNAME = 'theme-volkswagen';

export const VwGlobalStyle = createGlobalStyle`
    html.${VW_THEME_CLASSNAME} {
        /* For css variables antd override */
        --ant-primary-color: ${themeTokens.primaryColor};
        --ant-primary-color-hover: ${themeTokens.hoveredPrimaryColor};
        --ant-primary-color-active: ${themeTokens.primaryColor};

        /* font sizes */
        --button-font-size: ${themeTokens.buttonFontSize};
        --input-font-size: ${themeTokens.inputFontSize};
        
        /* checkboxes */
        --checkbox-width: 1.5rem;
        --checkbox-height: 1.5rem;

        --checkbox-summary-checked-inner-border-color: var(--ant-primary-color);
        --checkbox-checked-inner-border-color: #fff;
        --checkbox-summary-checked-inner-background-color: var(--ant-primary-color);
        --checkbox-checked-inner-background-color: #fff;
        
        /* For configurator pages */
        --configurator-text-color: var(--ant-primary-color);
        --configurator-border-radius: 0.5rem;
        --configurator-divider-color: #d7d7d7;
        --configurator-calculator-pre-summary-border-color: #d7d7d7;
        --configurator-calculator-summary-border-color: rgba(0,0,0,0.5);

        --configurator-back-color: #fff;
        --configurator-back-color-hover: #fff;
        --configurator-back-color-active: #fff;

        --configurator-widget-active-color: #fff;
        --configurator-widget-title-font-weight: 400;
        --configurator-widget-background: var(--ant-primary-color);
        --configurator-widget-text-color: #fff;

        --configurator-widget-popup-background: var(--ant-primary-color);
        --configurator-widget-popup-summary-text-color: var(--ant-primary-color);
        --configurator-widget-popup-text-color: #fff;
        --configurator-widget-popup-disabled-text-color: #fff;
        --configurator-widget-popup-text-color-opacity: 0.8;
        --configurator-widget-popup-calculator-background: #fff;

        --configurator-widget-bar-color: #ffffff7f;
        --configurator-widget-bar-open-color: #ffffff7f;

        --configurator-widget-checked-color: var(--ant-primary-color);

        --configurator-vehicle-select-height: 65px;
        --configurator-vehicle-select-label-padding-bottom: 8px;
        --configurator-widget-popup-calculator-field-background-color: rgba(0, 0, 0, 0.07);

        --configurator-widget-dealer-select-container-height: auto;
        --configurator-widget-dealer-select-container-form-item-display: flex;

        /* For calculator ui */
        --calculator-form-item-error-border: 1px var(--ant-error-color) solid;
        
        --calculator-field-background-color: rgba(0, 0, 0, 0.07);
        --calculator-field-label-padding: 0 11px;
        --calculator-field-label-color: rgba(0, 0, 0, 0.85);
        --calculator-field-disabled-label-color: rgba( 0 , 0 , 0 , 0.25);
        --calculator-field-padding: 10px 5px;
        --calculator-grid-item-gap: 10px;
        --calculator-grid-item-min-height: min-content;

        --calculator-comparison-form-item-height-default: 57px;
        --calculator-comparison-form-item-height-second: 57px;
        --calculator-comparison-below-condition-background: #f5f5f5;
        --calculator-comparison-form-item-ant-typography-padding-left-right: 11px;
        --calculator-comparison-mobile-form-item-padding-top: 45px;
        --calculator-comparison-mobile-form-item-padding-top-sm: 38px;
        --calculator-comparison-form-item-error-position: absolute;
        --calculator-comparison-vehicle-image-height: 337px;
        --calculator-comparison-vehicle-image-height-xl: 179px;
        --calculator-comparison-vehicle-image-height-lg: 121px;
        --calculator-comparison-vehicle-image-height-m: 180px;
        --calculator-comparison-vehicle-image-height-sm: 225px;

        --vehicle-image-border-radius: 0px;

        /* For image selection */
        --image-selection-border: 1px solid transparent;
        --image-selection-border-radius: 0px;
        --image-selection-active-border-color: var(--ant-primary-color);
        --image-selection-outline: 0px;
        --image-selection-outline-offset: 0px;
        --image-selection-active-outline-color: transparent;


        .ant-layout-header.ant-pro-fixed-header > .ant-pro-global-header {
            box-shadow: none;
            padding: 0;


            

            & .ant-pro-global-header-logo {
                position: absolute;
                line-height: 24px;

                & > div[class^="BasicProLayout__MenuButtonContainer"] {
                    height: 40px;
                }

                @media screen and (max-width: ${breakpoints.md}) {
                    margin: 0px 36px;
                }
            }


            & > div:nth-child(2) {
                display: flex;
                align-items: center;

                ${LogoContainer} {
                    position: initial;
                    width: auto;
                    margin: 0px 12px;
                }

                &:after,
                &:before {
                    content: "";
                    height: 3px;
                    background-color: var(--ant-primary-color);
                    display: block;
                }

                &:before {
                    width: 100%
                }

                &:after {
                    width: 64%;

                    @media screen and (max-width: ${breakpoints.md}) {
                        width: 100%;
                    }
                }
            }
        }

        .ant-layout-header {
            background-color: white;
            transition: 0.15s all ease-in-out;
        }
    }
`;

const VWGlobalStyles = () => {
    useEffect(() => {
        document.documentElement.classList.add(VW_THEME_CLASSNAME);

        return () => {
            document.documentElement.classList.remove(VW_THEME_CLASSNAME);
        };
    }, []);

    return (
        <>
            <NotificationGlobalStyle />
            <FooterGlobalStyle />
            <VwGlobalStyle />
        </>
    );
};

export default VWGlobalStyles;
